import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Box } from '@mui/material';
import { ActionItem, OrdersActionItemData } from '../types';
import { useLanguage } from 'context/AppContext';
import { useIsTierZero } from 'hooks/useSubscriptionTier';
import FeatureUnavailableNotice from 'components/FeatureUnavailableNotice';

type Props = {
  actionItem: ActionItem;
  data?: OrdersActionItemData | null;
};

// temporarily shows Feature Coming Soon message but is
//  intended to be the Orders version of DeliveriesActionItem
const OrdersActionItem = ({ actionItem, data: _ }: Props) => {
  const lang = useLanguage()[0].ActionItemsPage;

  const isTierZero = useIsTierZero();

  return isTierZero ? (
    <FeatureUnavailableNotice />
  ) : (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        '& path': {
          stroke: actionItem.colors.background,
          strokeWidth: '0.75px',
        },
      }}
    >
      <AutoAwesomeIcon style={{ fontSize: 100, color: actionItem.colors.foreground, marginTop: 50 }} />
      <Box mt={2} style={{ fontSize: 20 }}>
        {lang.featureComingSoon}
      </Box>
    </Box>
  );
};

export default OrdersActionItem;
